export const EVENT_TYPES = Object.freeze({
  hosted: 'hosted',
  external: 'external',
  aarShell: 'aar_shell',
  outlookVoc: 'outlook_voc',
  legacy: 'legacy',
});

export const EVENT_TYPE_VALUES = Object.freeze(Object.values(EVENT_TYPES));

export const EVENT_TYPE_LABELS = Object.freeze({
  [EVENT_TYPES.hosted]: 'Hosted Road Home event',
  [EVENT_TYPES.external]: 'External outreach event',
  [EVENT_TYPES.aarShell]: 'AAR shell',
  [EVENT_TYPES.outlookVoc]: 'Outlook VOC event',
  [EVENT_TYPES.legacy]: 'Legacy or test record',
});

export const EVENT_TYPE_SHORT_LABELS = Object.freeze({
  [EVENT_TYPES.hosted]: 'Hosted',
  [EVENT_TYPES.external]: 'External',
  [EVENT_TYPES.aarShell]: 'AAR Shell',
  [EVENT_TYPES.outlookVoc]: 'Outlook VOC',
  [EVENT_TYPES.legacy]: 'Legacy',
});

export const AAR_REPORTING_EVENT_TYPES = Object.freeze([
  EVENT_TYPES.hosted,
  EVENT_TYPES.external,
  EVENT_TYPES.aarShell,
  EVENT_TYPES.outlookVoc,
]);

export const VOC_AAR_CONTEXT_EVENT_TYPES = Object.freeze([
  EVENT_TYPES.hosted,
  EVENT_TYPES.external,
]);

export function normalizeEventType(value, fallback = '') {
  const normalizedValue = String(value ?? '').trim().toLowerCase();
  if (EVENT_TYPE_VALUES.includes(normalizedValue)) return normalizedValue;
  return fallback;
}

export function deriveEventType(eventLike = {}) {
  const explicitType = normalizeEventType(eventLike?.event_type);
  if (explicitType) return explicitType;

  const source = String(eventLike?.source ?? '').trim().toLowerCase();
  if (source === 'outlook_voc_events' || eventLike?.external_managed === true) {
    return EVENT_TYPES.outlookVoc;
  }

  if (source === 'manual_aar' || source === 'historical_google_form') {
    return EVENT_TYPES.aarShell;
  }

  if (!source || source === 'internal') {
    return eventLike?.external_managed === true ? EVENT_TYPES.outlookVoc : EVENT_TYPES.hosted;
  }

  return EVENT_TYPES.legacy;
}

export function isHostedEvent(eventLike = {}) {
  return deriveEventType(eventLike) === EVENT_TYPES.hosted;
}

export function isEventPageCapableEvent(eventLike = {}) {
  return isHostedEvent(eventLike);
}

export function isAarReportingEvent(eventLike = {}) {
  return AAR_REPORTING_EVENT_TYPES.includes(deriveEventType(eventLike));
}

export function isVocAarContextEvent(eventLike = {}) {
  return VOC_AAR_CONTEXT_EVENT_TYPES.includes(deriveEventType(eventLike));
}

export function formatEventTypeLabel(value, { short = false } = {}) {
  const normalizedValue = normalizeEventType(value, EVENT_TYPES.legacy);
  const labels = short ? EVENT_TYPE_SHORT_LABELS : EVENT_TYPE_LABELS;
  return labels[normalizedValue] || labels[EVENT_TYPES.legacy];
}

export function formatEventDropdownLabel(eventLike = {}) {
  const name = String(eventLike?.name || eventLike?.id || 'Untitled event').trim();
  const eventType = deriveEventType(eventLike);
  if (eventType === EVENT_TYPES.hosted) return name;
  return `${name} (${formatEventTypeLabel(eventType, { short: true })})`;
}
